import * as XLSX from 'xlsx';
import i18n from '../i18n';

const SOURCE_URL = 'https://oicstat.sesric.org';
const SOURCE_NAME = 'SESRIC - OIC Statistics Database (OICStat)';
const SESRIC_FULL_NAME = 'Statistical, Economic and Social Research and Training Centre for Islamic Countries (SESRIC)';

const shiftRange = (ref, count) => {
    const range = XLSX.utils.decode_range(ref);
    range.s.r += count;
    range.e.r += count;
    return range;
};

const insertRowsAbove = (sheet, rows) => {
    const count = rows.length;
    if (sheet['!ref']) {
        const range = XLSX.utils.decode_range(sheet['!ref']);
        for (let r = range.e.r; r >= range.s.r; r -= 1) {
            for (let c = range.s.c; c <= range.e.c; c += 1) {
                const from = XLSX.utils.encode_cell({ r, c });
                if (sheet[from]) {
                    sheet[XLSX.utils.encode_cell({ r: r + count, c })] = sheet[from];
                    delete sheet[from];
                }
            }
        }
        sheet['!ref'] = XLSX.utils.encode_range(shiftRange(sheet['!ref'], count));
    }
    (sheet['!merges'] || []).forEach((merge) => {
        merge.s.r += count;
        merge.e.r += count;
    });
    if (sheet['!autofilter']?.ref) {
        sheet['!autofilter'].ref = XLSX.utils.encode_range(shiftRange(sheet['!autofilter'].ref, count));
    }
    XLSX.utils.sheet_add_aoa(sheet, rows, { origin: 'A1' });
};

const stampRows = () => {
    const date = new Date().toISOString().split('T')[0];
    return [
        [i18n.t('excelExport.source', { url: SOURCE_URL })],
        [i18n.t('excelExport.downloaded', { date })],
        [],
    ];
};

// Use instead of XLSX.writeFile for every user-facing export: each sheet gets a source header and the file
// carries SESRIC as its source in the document properties. Not for files that are uploaded back, since the
// importers read the first row as the column header.
export const writeExcelFile = (workbook, filename) => {
    const rows = stampRows();
    workbook.SheetNames.forEach((name) => insertRowsAbove(workbook.Sheets[name], rows));

    workbook.Props = {
        ...workbook.Props,
        Title: filename.replace(/\.xlsx$/i, ''),
        Subject: `Data obtained from ${SOURCE_NAME}`,
        Author: 'SESRIC',
        Company: 'SESRIC',
        Keywords: 'SESRIC, OICStat',
        Comments: `This data was obtained from the ${SESRIC_FULL_NAME}, OICStat database: ${SOURCE_URL}`,
        CreatedDate: new Date(),
    };
    workbook.Custprops = {
        ...workbook.Custprops,
        Source: SOURCE_NAME,
        'Source URL': SOURCE_URL,
    };

    XLSX.writeFile(workbook, filename);
};
